import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    selector: 'sh-url-readonly-field',
    templateUrl: './url-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShUrlReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {}
